import { z } from 'zod';

import { SupplierRoleStatusSchema } from './supplier-role.schemas.js';

export const ChangeSupplierRoleStatusBodySchema = z.object({
  toStatus: SupplierRoleStatusSchema,
  reason: z.string().trim().max(500).optional(),
});

export type ChangeSupplierRoleStatusBody = z.infer<typeof ChangeSupplierRoleStatusBodySchema>;
